import { render, staticRenderFns } from "./Enviadas.vue?vue&type=template&id=4dfcbfbc&"
import script from "./Enviadas.vue?vue&type=script&lang=js&"
export * from "./Enviadas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports